/*eslint-disable*/
import { apiPga } from '../../../config/api'

const pgaService = {
  getCurrentPgaID: async (operationId) =>
    await getCurrentPgaID('', operationId),

  getPgaPerID: async (idPga) => await getPgaPerID('', idPga),

  getCurrentDraftPga: async (operationId) =>
    await getCurrentDraftPga(operationId),

  createInitialPga: async (pgaData) => {
    return await createInitialPga('', pgaData)
  },
  createDraftPga: async (pgaData) => {
    return await createDraftPga('', pgaData)
  },
  updateInitialPga: async (pgaData) => {
    return await updateInitialPga('', pgaData)
  },
  updateDraftPga: async (pgaData) => {
    return await updateDraftPga('', pgaData)
  },
  createModificationRequest: async (pgaData) => {
    return await createModificationRequest('', pgaData)
  },
  updateAcquisitionState: async (pgaData) => {
    return await updateAcquisitionState(pgaData)
  },
  getStatusList: async (data) => {
    const statusData = {
      statusList: [
        {
          statusId: 1,
          status: 'Previsto',
        },
        {
          statusId: 2,
          status: 'En Curso',
        },
        {
          statusId: 3,
          status: 'Evaluacion',
        },
        {
          statusId: 4,
          status: 'Desierto',
        },
        {
          statusId: 5,
          status: 'Fracasado',
        },
        {
          statusId: 6,
          status: 'Adjudicado',
        },
        {
          statusId: 7,
          status: 'Anulado',
        },
        {
          statusId: 8,
          status: 'Contratado',
        },
        {
          statusId: 9,
          status: 'Contrato',
        },
        {
          statusId: 10,
          status: 'Contrato Terminado',
        },
      ],
    }
    if (!data?.statusList) {
      return statusData
    }
    return await getStatusList(data)
  },
  getModificated: async (id) => {
    const { data } = await apiPga.get(`/getmodificationrequestlist/${id}`)
    return data
  },
  getApplicationRegulations: async () => {
    const { data } = await apiPga.get(
      `/pga/getapplicationregulations?api-version=1.0`,
    )
    return data
  },
  getMethods: async () => {
    const { data } = await apiPga.get(`/pga/getmethods?api-version=1.0`)
    return data
  },
  getSelectionProcesses: async () => {
    const { data } = await apiPga.get(
      `/pga/getselectionprocesses?api-version=1.0`,
    )
    return data
  },
  getRevisionTypes: async () => {
    const { data } = await apiPga.get(`/pga/getrevisiontypes?api-version=1.0`)
    return data
  },
  getHistory: async (id) => {
    const { data } = await apiPga.get(
      `pga/gethistoricpgalist/${id}?api-version=1.0`,
    )

    return data
  },

  getComponents: async (operationId) => {
    const componentsData = {
      componentsFromPgi: [
        {
          operationId: 500523,
          pgiId: 98,
          componentId: 1,
          componentName: 'Carreteras',
        },
        {
          operationId: 500523,
          pgiId: 98,
          componentId: 2,
          componentName: 'Red eléctrica',
        },
        {
          operationId: 500523,
          pgiId: 98,
          componentId: 3,
          componentName: 'Maquinaria',
        },
        {
          operationId: 500523,
          pgiId: 98,
          componentId: 4,
          componentName: 'Varios',
        },
      ],
    }
    const { data } = await apiPga.get(
      `pga/getcomponentsnamefrompgitlist/${operationId}?api-version=1.0`,
    )
    if (!data.componentsFromPgi) {
      return componentsData
    }
    return data
  },

  upsertoperationexpense: async (data) => {
    return await upsertoperationexpense(data)
  },
  operationexpenselist: async (pgaId) => {
    return await operationexpenselist(pgaId)
  },
  deleteoperationexpense: async (data) => {
    return await deleteoperationexpense(data)
  },
  createCommentDeny: async (commentDeny) => {
    return await createCommentDeny(commentDeny)
  },
  createComment: async (commentDeny) => {
    return await createComment(commentDeny)
  },
  updateComment: async (comment) => {
    return await updateComment(comment)
  },
  checkverifications: async (data) => {
    return await checkverifications(data)
  },
  approveModificationRequest: async (aprrovalRequest) => {
    return await approveModificationRequest(aprrovalRequest)
  },
  returnRequest: async (sendReturnRequest) => {
    return await returnRequest(sendReturnRequest)
  },
  sendnotificationpgaendreview: async (data) => {
    return await sendnotificationpgaendreview(data)
  },
}

function getCurrentPgaID(userToken, operationId) {
  return new Promise((resolve, reject) => {
    apiPga
      .get(`pga/getcurrentpgaid/${operationId}?api-version=1.0`)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => reject(error))
  })
}
function getPgaPerID(userToken, id) {
  return new Promise((resolve) => {
    apiPga
      .get(`pga/getpgabyid/${id}?api-version=1.0`)
      .then((result) => {
        resolve(result.data)
      })
      .catch((error) => console.log(error))
  })
}
function getCurrentDraftPga(operationId) {
  return new Promise((resolve) => {
    if (operationId !== undefined) {
      apiPga
        .get(`pga/getcurrentdraftpga/${operationId}?api-version=1.0`)
        .then((result) => {
          const { data } = result
          resolve(data)
        })
        .catch((error) => console.log(error))
    }
  })
}
function createInitialPga(userToken, data) {
  return new Promise((resolve, reject) => {
    apiPga
      .post('/pga/createinitialpga?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => reject(error))
  })
}
function createDraftPga(userToken, data) {
  return new Promise((resolve, reject) => {
    apiPga
      .post('/pga/createdraftpga?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => reject(error))
  })
}
function updateInitialPga(userToken, data) {
  return new Promise((resolve, reject) => {
    apiPga
      .post('/pga/updateinitialpga?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => reject(error))
  })
}
function updateDraftPga(userToken, data) {
  return new Promise((resolve, reject) => {
    apiPga
      .post('/pga/updatedraftpga?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => reject(error))
  })
}
function getStatusList(data) {
  return new Promise((resolve) => {
    apiPga
      .post('/pga/getStatusList?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function createCommentDeny(commentDeny) {
  return new Promise((resolve) => {
    apiPga
      .post('/pga/rejectverificationcoment?api-version=1.0', commentDeny)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function createComment(commentDeny) {
  return new Promise((resolve) => {
    apiPga
      .post('/pga/createcoment?api-version=1.0', commentDeny)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function updateComment(comment) {
  return new Promise((resolve) => {
    apiPga
      .post('/pga/updatecomment?api-version=1.0', comment)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function checkverifications(data) {
  return new Promise((resolve) => {
    apiPga
      .post('/pga/checkverifications?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function approveModificationRequest(aprrovalRequest) {
  return new Promise((resolve) => {
    apiPga
      .post('/pga/approvemodificationrequest?api-version=1.0', aprrovalRequest)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function createModificationRequest(userToken, data) {
  return new Promise((resolve) => {
    apiPga
      .post('/pga/createmodificationrequest?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function updateAcquisitionState(data) {
  return new Promise((resolve) => {
    apiPga
      .post(`pga/updateacquisitionstate?api-version=1.0`, data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function returnRequest(sendReturnRequest) {
  return new Promise((resolve) => {
    apiPga
      .post('/pga/createmodificationrequest?api-version=1.0', sendReturnRequest)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}

function upsertoperationexpense(data) {
  return new Promise((resolve) => {
    apiPga
      .post('/operationexpense/upsertoperationexpense?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}

function operationexpenselist(pgaId) {
  return new Promise((resolve) => {
    apiPga
      .get(
        `/operationexpense/operationexpenselist?pgaId=${pgaId}&api-version=1.0`,
      )
      .then((result) => {
        const { data } = result
        resolve(data)
      })
      .catch((error) => console.log(error))
  })
}
function deleteoperationexpense(data) {
  return new Promise((resolve) => {
    apiPga
      .post('/operationexpense/deleteoperationexpense?api-version=1.0', data)
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
function sendnotificationpgaendreview(data) {
  return new Promise((resolve) => {
    apiPga
      .post(
        '/pga/sendnotificationpgareviewcompletecommand?api-version=1.0',
        data,
      )
      .then((data) => {
        resolve(data)
      })
      .catch((error) => resolve(error))
  })
}
export default pgaService
